/*
  Returns the last 10 digits of a phone number with non-number characters removed
*/
export const sanitizePhoneNumber = (phoneNumber: string): string => {
  return phoneNumber?.replace(/\D/g, '')?.slice(-10) || ''
}
